  <div class="px-4 mt-2">
      <div class="size-[72px] bg-brand-500 text-white font-title text-4xl font-medium px-2 grid justify-center items-center rounded-xl">
          {{ getShortSchemaName(membership()?.name || '') }}
      </div>
      <div class="mt-2 text-sm text-gray-500">Comunidad de regantes</div>
      <div class="text-gray-800 font-title text-4xl font-bold">{{membership()?.name}}</div>

      <div class="flex mt-6 gap-2">
          <!-- Card dotació -->
           @if (schemaProperties()?.dotation) {
              <div class="flex-1 max-[550px]:grid flex border bg-white rounded-2xl py-4 px-5 items-start gap-4">
                  <div class="w-fit h-fit p-3 bg-gray-100 rounded-xl">
                      <lib-icon name="flow" class="size-6"></lib-icon>
                  </div>
                  <div class="gap-1">
                      <div class="truncate text-gray-500 font-title text-sm font-normal">
                          Dotación
                      </div>
                      <div class="mt-2">
                            @if(schemaProperties()) {
                                <span class="text-gray-800 font-title text-4xl font-bold">{{schemaProperties()?.dotation?? "-"}}</span>
                                <span class="text-gray-800 font-title text-sm font-semibold"> m3</span>
                            } @else {
                                <div class="h-11 w-[120px] bg-gray-300 rounded-xl animate-pulse"></div>
                            }
                      </div>
                  </div>
              </div>
          }
          <!-- Card consum dia anterior -->
          <div class="flex-1 max-[550px]:grid flex border bg-white rounded-2xl py-4 px-5 items-start gap-4">
              <div class="w-fit h-fit p-3 bg-gray-100 rounded-xl">
                  <lib-icon name="calendar" class="size-6"></lib-icon>
              </div>
              <div>
                  <div class="truncate text-gray-500 font-title text-sm font-normal">
                      Consumo ayer
                  </div>
                  <div class="mt-2">
                      @if(schemaProperties()) {
                          <span class="text-gray-800 font-title text-4xl font-bold">{{schemaProperties()?.totalConsumption?? "-"}}</span>
                          <span class="text-gray-800 font-title text-sm font-semibold"> m3</span>
                      } @else {
                          <div class="h-11 w-[120px] bg-gray-300 rounded-xl animate-pulse"></div>
                      }
                  </div>
              </div>
          </div>
          <!-- Card acumulat avui -->
          <div class="flex-1 max-[550px]:grid flex border bg-white rounded-2xl py-4 px-5 items-start gap-4">
              <div class="w-fit h-fit p-3 bg-gray-100 rounded-xl">
                  <lib-icon name="bar-2" class="size-6"></lib-icon>
              </div>
              <div>
                  <div class="truncate text-gray-500 font-title text-sm font-normal">
                      {{ isGestor() ? 'Acumulado hoy' : 'Mi acumulado hoy' }}
                  </div>
                  <div class="mt-2">
                      @if (!loadingAccumulated()) {
                          <span class="text-gray-800 font-title text-4xl font-bold">{{todayAccumulated() ?? "-"}}</span>
                          @if (todayAccumulated() !== null) {
                              <span class="text-gray-800 font-title text-sm font-semibold"> m3</span>
                          }
                      } @else {
                          <div class="h-11 w-[120px] bg-gray-300 rounded-xl animate-pulse"></div>
                      }
                  </div>
              </div>
          </div>
      </div>

      <!-- Sensores: accordion per grup de visualització (només grups amb sensors) -->
      @if (loadingGroupSensors()) {
          <div class="mt-6">
              <div class="h-6 w-24 bg-gray-200 rounded-lg animate-pulse mb-3"></div>
              <div class="flex flex-col gap-2">
                  <div class="h-16 w-full bg-gray-200 rounded-2xl animate-pulse"></div>
                  <div class="h-16 w-full bg-gray-200 rounded-2xl animate-pulse"></div>
              </div>
          </div>
      } @else if (visualizationGroups().length > 0) {
          <div class="mt-6">
              <div class="text-gray-800 font-title text-lg font-semibold mb-3">Sensores</div>
              <div class="flex flex-col gap-2">
                  @for (group of visualizationGroups(); track group.id) {
                      <div class="border bg-white rounded-2xl overflow-hidden">
                          <div class="accordion-header w-full flex items-center gap-4 py-4 px-5 cursor-pointer select-none" (click)="toggleGroup(group.id)">
                              <div class="w-fit h-fit p-3 bg-gray-100 rounded-xl">
                                  <lib-icon name="sensor" class="size-6"></lib-icon>
                              </div>
                              <span class="flex-1 text-left text-gray-800 font-title font-semibold">{{group.name}}</span>
                              <svg class="size-6 flex-shrink-0 text-gray-400 transition-transform duration-200" [class.rotate-180]="isGroupExpanded(group.id)" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                          </div>
                          @if (isGroupExpanded(group.id)) {
                              <div class="border-t border-gray-100 px-4 py-2 grid gap-2">
                                  @for (sensor of groupSensorsMap()[group.id]; track sensor.id) {
                                      <sensor-list-card [sensor]="sensor"></sensor-list-card>
                                  }
                              </div>
                          }
                      </div>
                  }
              </div>
          </div>
      }
  </div>